import { fromJS } from 'immutable';

import { INIT, INIT_SUCCESS, INIT_FAILED, SET_TIME, SET_SEARCH } from './constants';

export const initialState = fromJS({
  loading: false,
  error: false,
  time: 'all',
  search: '',
});

function deedsPageReducer(state = initialState, action) {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case SET_SEARCH:
      return state.merge({ search: action.search });

    case SET_TIME:
      return state.merge({ time: action.time });

    default:
      return state;
  }
}

export default deedsPageReducer;
